$(document).ready(function(){
    let ttcTranslate = $('#ttc-translate').text();
    // Check if there are at least one product filled
    $('.addToCart').on('submit', function(e){
        e.preventDefault();
        // $.ajax({
        //     url: route('cart.store'),
        //     type: 'POST',
        //     data: $(this).serialize(),
        //     dataType: "json",
        //     success: function(data){
        //         if(data.state == "ok"){
        //             $('.modal').modal('show');
        //         }
        //     },
        //     error: function(data){
        //         console.error(data);
        //         $('.modal-body').html('<h2>Une erreur est survenue</h2>');
        //         $('.modal').modal('show');
        //     },
        // });
        $.ajax({
            url: route('cart.store'),
            type: 'POST',
            data: $(this).serialize(),
            dataType: "json",
        }).done(function(data) {
            // console.log(data)
            if(data.state == "ok"){
                $('.modal').modal('show');
            }
        }).fail(function( jqXHR, textStatus ) {
            console.error(textStatus);
            $('.modal-body').html('<h2>Une erreur est survenue</h2>');
            $('.modal').modal('show');
        });
    });

    $('.btn-delete').on('click', function(){
        var conf_delete = confirm($(this).data('translation'));
        if (conf_delete == true){
            var product_id = $(this).data('product');
            $.ajax({
                url: route('cart.remove', product_id),
                type: 'GET',
                data: {},
                success: function(data){
                    if (data != 'null'){
                        $('.cartProdutcs .product.product'+product_id).remove();
                        $('.cartProdutcs .product-cart.product'+product_id).remove();
                        calcCart();
                    }
                }
            });
        }

        return false;
    });

    $('.btn-discount').on('click', function(){
        let code = $('#promo_code').val();
        $.ajax({
            url: route('discounts.get'),
            type: 'GET',
            data: {'code': code},
            success: function(data){
                if (data != 'null'){
                    tab = JSON.parse(data);
                    if ("result" in tab)
                        alert(tab.message);
                    else {
                        let html = '';
                        html += '<div class="col-2"><a href="#" class="btn btnSuppDiscount" data-ref="'+tab.code+'"><svg class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" version="1.1"><g id="surface1"><path style=" " d="M 7.5 1 C 3.914063 1 1 3.914063 1 7.5 C 1 11.085938 3.914063 14 7.5 14 C 11.085938 14 14 11.085938 14 7.5 C 14 3.914063 11.085938 1 7.5 1 Z M 10.207031 9.5 L 9.5 10.207031 L 7.5 8.207031 L 5.5 10.207031 L 4.792969 9.5 L 6.792969 7.5 L 4.792969 5.5 L 5.5 4.792969 L 7.5 6.792969 L 9.5 4.792969 L 10.207031 5.5 L 8.207031 7.5 Z "></path></g></svg></a></div>';
                        html += '<div class="col-5">'+tab.code+'</div>';
                        html += '<div class="col-5 text-right discount-value" data-value="'+tab.discount+'">-'+tab.discount+'%</div>';
                        $('.added-discount .row').html(html);
                        calcCart();
                    }
                }
            }
        });
        $('#promo_code').val('');
        return false;
    });

    $(document).on('click', '.btnSuppDiscount', function(){
        let code = $(this).attr('data-ref');
        // console.log(code);
        $.ajax({
            url: route('discounts.remove'),
            type: 'GET',
            data: {'code': code},
            success: function(data){
                if (data == 'ok'){
                    $('.added-discount .row').empty();
                    calcCart();
                }
            }
        });
    });

    $('.form-control.quantity').on('change', function(){
        let product_id = $(this).data('product');
        let qty = parseInt($(this).val());
        let old_qty = parseInt($('input[name="cartProducts['+product_id+'][old_quantity]"]').val());
        let unitPrice = $('input[name="cartProducts['+product_id+'][unit_price_ref]"]').val();
            if (old_qty != qty && qty >= 1){
                $.ajax({
                    url: route('cart.changeQty', [product_id, qty]),
                    type: 'GET',
                    data: {},
                    success: function(data){
                        if (data != 'null'){
                            //Update qtt & price in body & recap
                            $('input[name="cartProducts['+product_id+'][old_quantity]"]').val(qty);
                            $('.product.cart.product'+product_id+' .row_price').html(parseFloat(qty*unitPrice) + " € " + ttcTranslate);
                            $('.product-cart.product'+product_id+' .product-quantity').html(qty);
                            $('.product-cart.product'+product_id+' .product-price').html(parseFloat(qty*unitPrice) + " € " + ttcTranslate);
                            // Update qtt & price in cart & subtotal & total
                            calcCart();
                        }
                    }
                });
            }

    });

    $('.btnValiderCart').on('click', function(){
        $('#saveCart').trigger('submit');
    });

    $('.btnValidateForm').on('click', function(){
        let form = $('#' + $(this).data('form-id')).get(0)
        if (!form.checkValidity()) {
            // Create the temporary button, click and remove it
            var tmpSubmit = document.createElement('button')
            form.appendChild(tmpSubmit)
            tmpSubmit.click()
            form.removeChild(tmpSubmit)
        } else {
            $('#' + $(this).data('form-id')).trigger('submit');
        }
    });

    $('#payment-confirm').on('submit', function(e){
        e.preventDefault();
        if (!this.checkValidity()) {
            // Create the temporary button, click and remove it
            var tmpSubmit = document.createElement('button')
            this.appendChild(tmpSubmit)
            tmpSubmit.click()
            this.removeChild(tmpSubmit)
        } else {
            // Form is valid, let the user proceed or do whatever we need to
            let rdPayment = $('input[name=payment]:checked', '#payment-confirm').val();
            if(rdPayment === 'cb'){
                $('#paymentCbForm').trigger('submit');
            }
            else{
                $(this).off('submit').trigger('submit');
            }
        }
    });

    $('#deliveryEditModal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget) // Button that triggered the modal
        let address_id = button.data('address-id') // Extract info from data-* attributes
        let modal = $(this)
        // vider la modal
        modal.find('.js_edit_address').html('Loading...')
        // chargement ajax
        $.ajax({
            url: route('cart.address.form', [address_id]),
            type: 'GET',
            success: function(data){
                let container = $(data)
                // Update the modal's content.
                modal2 = modal.find('.js_edit_address').html('').append(container)
            }
        });
    });

    $('input.js_address_current_selected').on('change', function(){
        let input = $(this)
        let country = input.data('country');
        let layout = $('#checkout__shipping_address--layout-' + input.data('type'))
        $.ajax({
            url: route('cart.address.layout', [input.val(), input.data('type')]),
            type: 'GET',
            success: function(data){
                // console.log(data)
                let container = $(data)
                // Update the modal's content.
                layout.html('').append(container)
            }
        });
        $('#checkout__shipping_address--change-address-' + input.data('type')).data('address-id', input.val())
        if (country == 1)
            $('.card-relay-suggested').removeClass('d-none');
        else
            $('.card-relay-suggested').addClass('d-none');
        $('#shippingPredictDefaultPrice').val(input.data('price-shipping'))
        deliveryCalcCart()
    });

    $(document).on('click', "input[name='relay_dpd']", function(){
        $('#relay-shipping').prop('checked', true);
        $('html, body').animate({
            scrollTop: $("#recap_col").offset().top - 150
        }, 2000);
    });
});

function deliveryCalcCart(){
    // Price change
    let subTotalPrice = $('#totalFixedCart').val()
    let fullTotalPrice = $('#ht_total-price').val()
    let price = $('#shippingPredictDefaultPrice').val()
    // Modification des prix
    $('.price-shipping-detail').text(price)
    totalHt = parseFloat(subTotalPrice) + parseFloat(price)
    $('.totalPriceHT').text(totalHt.toFixed(2))
    totalTtc = (parseFloat(fullTotalPrice) + parseFloat(price))
    $('.totalPriceTTC').text(totalTtc.toFixed(2))
}

function calcCart(){
    let countProduct = 0;
    let totalCart = 0;
    let totalDiscountedCart = 0;

    let discount = 0;
    let totalFinalePrice = 0;
    let fraisPort = 0;
    if ($('.discount-value').length)
        discount = $('.discount-value').attr('data-value');
        
    $( ".row_price" ).each(function() {
            totalCart += parseFloat($(this).text().slice(0, -2));
        if (discount > 0)
            totalDiscountedCart += parseFloat($(this).text().slice(0, -2)) - (parseFloat($(this).text().slice(0, -2)) * (discount / 100));
    });
    if (discount == 0)
        totalDiscountedCart = totalCart;

    if (totalCart < 100){
        // totalFinalePrice = +totalDiscountedCart + +(5.56 * 1.2);
        // fraisPort = (5.56 * 1.2)+" €";
        // fraisPort = fraisPort.toFixed(2)
        totalFinalePrice = totalDiscountedCart;
        fraisPort = $('#free-translate').text();
    } else {
        totalFinalePrice = totalDiscountedCart;
        fraisPort = $('#free-translate').text();
    }
    totalFinalePrice = (totalFinalePrice).toFixed(2);

    $( ".form-control.quantity").each(function(){
        countProduct += parseFloat($(this).val());
    });

    // $('.price-total-ht').html('<p class="h3 text-right">Total : '+totalCart+ " €</p>");
    $('.total-price').html(totalCart.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

    // console.log(totalFinalePrice);
    $('.totalPriceTTC').html(totalFinalePrice.replace(/\d(?=(\d{3})+\.)/g, '$&,'));

    $('.js_price-total-ht-topbar').html(totalFinalePrice.replace(/\d(?=(\d{3})+\.)/g, '$&,')+" € " + $('#ttc-translate').text());
    $('.frais-port').html(fraisPort);
    $('.totalPanier').html(totalFinalePrice + " " + $('#ttc-translate').text());
    $('#number_products').val(countProduct);
    $('.number-products-text').html(countProduct)
    $('.mycart .caps').html(countProduct);
}